export default __webpack_public_path__ + "static/media/indexRatePlusVariableMargin.247c710d.svg";